import ICLICommand from "flow/interfaces/ICLICommand";
import Writer from "flow/cli/Writer";
import manifestManager from "flow/utils/manifestManager";

type ModuleItem = {
    id: string;
    name: string;
    description: string;
};

export default {
    name: "modules",
    description: "Lists loaded modules and their versions",
    options: [],
    arguments: [],
    callback(writer: Writer) {
        const modules: ModuleItem[] = manifestManager.getModuleList();

        modules.forEach(m => {
            writer.output.writeLine(`${m.name} | ${m.id} | ${m.description}`);
        });

        return {
            input: ""
        };
    }
} as ICLICommand;
